/* ============================================================================
   ENGRAVING (gravure in-house) — moteur d'aperçu live + câblage panier
   Remplace l'app « Live Product Options ».

   UI rendue une seule fois (<engraving-option>). La config de CHAQUE format est dans des
   <script class="engraving-cfg" data-format="…"> (émis par chaque bloc). Au changement de
   variante (event `variant:change` ou clic radio), on relit le format sélectionné et on applique
   la config correspondante (mockup, géométrie, longueur max, prix, libellés) SANS dépendre d'un
   re-render du thème -> l'aperçu suit la variante.

   - Aperçu gravé (canvas HD) dans #engraving-preview.
   - Propriétés de ligne : Engraving=yes, Wording=<texte>, _engraving_price=<centimes>.
     Le +10€ est appliqué par la Shopify Function Cart Transform qui lit _engraving_price.
   - Nettoyage de caractères + alerte ; compteur de caractères ; persistance entre variantes.
   ============================================================================ */
(function () {
  if (window.__memoEngravingDefined) return;
  window.__memoEngravingDefined = true;

  var DESKTOP_MIN = 1008;
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); }

  // Ajoute un montant (unités majeures) au 1er nombre d'un texte de prix, en gardant le format
  // (symbole/placement) et SANS forcer de décimales si le prix de base est rond. Ex. "CHF 240" +10 -> "CHF 250".
  function addMoney(text, feeMajor) {
    if (text == null) return text;
    var m = String(text).match(/\d[\d.,'   ]*\d|\d/);
    if (!m) return text;
    var raw = m[0];
    var clean = raw.replace(/[^\d.,]/g, '');
    var hasDec = /[.,]\d{2}$/.test(clean);
    var sep = hasDec ? clean.charAt(clean.length - 3) : '';
    var intStr = (hasDec ? clean.slice(0, -3) : clean).replace(/[.,]/g, '');
    var val = parseInt(intStr || '0', 10) + (hasDec ? parseInt(clean.slice(-2), 10) / 100 : 0);
    var nv = val + (parseFloat(feeMajor) || 0);
    var out = hasDec ? (Math.round(nv * 100) / 100).toFixed(2).replace('.', sep) : String(Math.round(nv));
    return String(text).replace(raw, out);
  }

  // Cache d'images partagé : les mockups de tous les formats sont préchargés -> changement de variante instantané.
  var IMG_CACHE = {};
  function cacheImg(url) {
    if (!url) return null;
    if (!IMG_CACHE[url]) { var im = new Image(); im.crossOrigin = 'anonymous'; im.src = url; IMG_CACHE[url] = im; }
    return IMG_CACHE[url];
  }

  class EngravingOption extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.ratio = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3);

      this.checkbox = this.querySelector('input[name="engraving_enabled"]'); // bascule UI (non soumise)
      this.wordingWrap = this.querySelector('.engraving__wording');
      this.wording = this.querySelector('.engraving__input');               // propriété ligne « Wording » = texte
      this.priceInput = this.querySelector('[data-engraving-price]');
      this.flagInput = this.querySelector('[data-engraving-flag]');         // propriété ligne « Engraving » = "yes" (compat BC)
      this.countEl = this.querySelector('[data-engraving-count]');
      this.alertEl = this.querySelector('.engraving__alert');
      this.labelTextEl = this.querySelector('.engraving__label-text');
      this.labelActiveEl = this.querySelector('.engraving__label-active');
      this.feeEl = this.querySelector('.engraving__fee');

      if (this.wording) { this.wording.disabled = true; this.wording.required = false; }
      if (this.priceInput) { this.priceInput.disabled = true; this.priceInput.value = ''; }
      if (this.flagInput) { this.flagInput.disabled = true; }

      // Mémorise la place d'origine de #engraving-preview (dans la galerie) pour pouvoir l'y
      // remettre après l'avoir déplacé (mobile) — évite qu'il reste « coincé » au switch éditeur.
      var $pv = this.previewEl();
      if ($pv && !this._pvHome) this._pvHome = { parent: $pv.parentElement, next: $pv.nextElementSibling };

      this._readMap();
      this._applyConfig(); // config du format sélectionné
      // re-applique une fois tous les <script.engraving-cfg> des autres formats parsés + précharge les mockups
      var selfInit = this;
      requestAnimationFrame(function () { selfInit._applyConfig(); selfInit._preloadMockups(); });

      this._initPriceWatch();

      var self = this;
      if (this.checkbox) this.checkbox.addEventListener('change', function () { self._onToggle(self.checkbox.checked, true); });
      if (this.wording) this.wording.addEventListener('input', function () { self._onWording(); });

      // pilotent la case cachée engraving_enabled (source unique lue par le reste du code).
      this.swatches = this.querySelectorAll('.engraving__swatch input[type="radio"]');
      if (this.swatches && this.swatches.length) {
        this.swatches.forEach(function (r) {
          r.addEventListener('change', function () {
            if (!r.checked || !self.checkbox) return;
            var on = r.value === 'yes';
            self.checkbox.checked = on;
            self._onToggle(on, on); // focus le champ quand on active
          });
        });
      }

      // Changement de variante -> ré-applique la config du nouveau format (mockup, etc.).
      // On lit le format DIRECTEMENT depuis l'événement (autoritatif, pas de course avec le radio),
      // puis on ré-applique en plusieurs passes (la galerie est re-rendue en différé).
      document.addEventListener('variant:change', function (e) {
        var fmt = (e && e.detail && e.detail.variant) ? norm(self._fmtFromVariant(e.detail.variant)) : null;
        self._applyConfig(fmt);
        // le bouton d'achat est re-rendu (nouveau prix de base) : on ré-attache l'observer + ré-applique
        [250, 600, 1100].forEach(function (ms) { setTimeout(function () { self._applyConfig(fmt); self._initPriceWatch(); }, ms); });
      });

      document.addEventListener('change', function (e) {
        // radio (pastilles de format) OU <select> (menu déroulant, ex. filage par senteur)
        if (e.target && (e.target.type === 'radio' || e.target.tagName === 'SELECT')) { self._scheduleReapply(); setTimeout(function () { self._applyConfig(); }, 400); }
      });

      // Bascule mobile/desktop (éditeur de thème, rotation, redimensionnement) : l'aperçu et la
      // galerie dépendent de la largeur -> on ré-applique l'état propre après chaque resize.
      var rzT;
      window.addEventListener('resize', function () {
        clearTimeout(rzT);
        rzT = setTimeout(function () {
          if (self.checkbox && self.checkbox.checked) self._showEngraving();
          else self._restoreGallery();
        }, 200);
      });

      // Restauration de l'état si la gravure était activée.
      // ⚠️ La persistance ne vaut QUE pour le MÊME produit (re-render variante) : le thème Prestige
      // utilise des transitions de page (contexte JS conservé), donc window.__memoEngrState survit
      // aux navigations produit -> sans ce garde-fou, la gravure « collait » d'un produit à l'autre
      // (galerie masquée + aperçu vide = page « vide au début »). On compare data-product.
      var st = window.__memoEngrState;
      var sameProduct = st && st.product != null && st.product === (this.dataset.product || '');
      if (this.checkbox && this.checkbox.checked) {
        this._onToggle(true, false);
      } else if (st && st.on && sameProduct && this.checkbox) {
        this.checkbox.checked = true;
        if (this.wording && st.wording != null) this.wording.value = st.wording;
        this._onToggle(true, false);
      } else {
        // État propre garanti : galerie visible, aperçu masqué (efface tout résidu d'une page SPA précédente).
        this._restoreGallery();
      }
      this._updateCount();
    }

    /* ----------------------------------------------------- Config par format */
    _readMap() {
      this.map = {};
      var scripts = document.querySelectorAll('script.engraving-cfg');
      for (var i = 0; i < scripts.length; i++) {
        try {
          var c = JSON.parse(scripts[i].textContent);
          this.map[norm(c.format)] = c;
        } catch (e) {}
      }
    }

    _currentFormat() {
      var i, m;
      // 1) source de vérité : radio « Format » coché (pastilles : perfume, cap-camarat...)
      var radios = document.querySelectorAll('input[type=radio]:checked');
      for (i = 0; i < radios.length; i++) {
        var r = radios[i];
        var lab = (r.id && document.querySelector('label[for="' + (r.id + '').replace(/"/g, '\\"') + '"]')) || (r.closest && r.closest('label'));
        var t = lab ? lab.textContent : '';
        m = t.match(/\d+\s*ml/i);
        if (m && this.map[norm(m[0])]) return norm(m[0]);
        if (t && this.map[norm(t)]) return norm(t); // libellé non-ml (ex. senteur)
      }
      // 2) <select> de variante (menu déroulant, ex. filage par senteur : Patchouli, Amber...)
      var selects = document.querySelectorAll('variant-picker select, .variant-picker select, product-form select, .product-form select');
      for (i = 0; i < selects.length; i++) {
        var opt = selects[i].options ? selects[i].options[selects[i].selectedIndex] : null;
        if (!opt) continue;
        var cands = [opt.value, opt.textContent];
        for (var j = 0; j < cands.length; j++) {
          var s = String(cands[j] || '');
          m = s.match(/\d+\s*ml/i);
          var key = m ? norm(m[0]) : norm(s);
          if (this.map[key]) return key;
        }
      }
      // 3) repli : format initial de l'UI
      return norm(this.dataset.format || '');
    }

    _fmtFromVariant(v) {
      if (!v) return '';
      var raw = v.option1 || (v.options && v.options[v.options.length - 1]) || v.title || '';
      var m = String(raw).match(/\d+\s*ml/i);
      return m ? m[0] : raw;
    }

    _applyConfig(forceKey) {
      this._readMap(); // les <script.engraving-cfg> des autres formats peuvent arriver après ce bloc
      var key = (forceKey && this.map[forceKey]) ? forceKey : this._currentFormat();
      var c = this.map[key];
      if (!c) { for (var k in this.map) { c = this.map[k]; break; } } // 1er dispo
      if (!c) return;
      var prevMockup = this.cfg && this.cfg.mockup;
      this.cfg = {
        mockup: c.mockup,
        fee: parseInt(c.fee, 10) || 0,
        feeMajor: (c.feeMajor != null ? c.feeMajor : Math.round((parseInt(c.fee, 10) || 0) / 100)), // valeur de la propriété commande, en euros entiers
        feeMoney: c.feeMoney,
        baseMoney: c.baseMoney,
        totalMoney: c.totalMoney,
        max: parseInt(c.max, 10) || 22,
        min: parseInt(c.min, 10) || 1,
        font: c.font || 'Optima',
        fontSize: num(c.fontSize, 34),
        textColor: c.textColor || '#ECCB9E',
        strokeColor: c.strokeColor || '#000000',
        strokeWidth: num(c.strokeWidth, 0.6),
        angle: num(c.angle, 270),
        refX: num(c.refX, 706),
        refY: num(c.refY, 294),
        refWidth: num(c.refWidth, 79),
        refHeight: num(c.refHeight, 554),
        centered: !!c.centered,
        autoScale: !!c.autoScale,
        letterSpacing: num(c.letterSpacing, 50),
        size: num(c.canvasSize, 1000),
        uppercase: !!c.uppercase,
        clean: c.clean || '',
        checkboxLabel: c.checkboxLabel,
        checkboxLabelActive: c.checkboxLabelActive,
        wordingLabel: c.wordingLabel,
        shadowColor: c.shadowColor || 'rgba(0,0,0,0.5)',
        shadowBlur: num(c.shadowBlur, 2),
        shadowX: num(c.shadowX, 0.5),
        shadowY: num(c.shadowY, 1)
      };
      try { this.cleanRe = this.cfg.clean ? new RegExp(this.cfg.clean, 'g') : null; }
      catch (e) { this.cleanRe = null; }

      // Libellés + prix + contraintes
      if (this.labelTextEl && this.cfg.checkboxLabel != null) this.labelTextEl.textContent = this.cfg.checkboxLabel;
      if (this.labelActiveEl) this.labelActiveEl.textContent = (this.cfg.checkboxLabelActive != null && this.cfg.checkboxLabelActive !== '') ? this.cfg.checkboxLabelActive : this.cfg.checkboxLabel;
      // feeMoney contient le format monnaie du thème (ex. <span class="money">10€</span>) -> innerHTML
      if (this.feeEl && this.cfg.feeMoney != null) this.feeEl.innerHTML = this.cfg.feeMoney;
      if (this.wording) { this.wording.maxLength = this.cfg.max; this.wording.minLength = this.cfg.min; }
      if (this.priceInput && !this.priceInput.disabled) this.priceInput.value = String(this.cfg.feeMajor);
      this._updateCount();

      var self = this;
      var on = this.checkbox && this.checkbox.checked;
      this._updatePrice(on); // rafraîchit le surcoût (devise/format)
      // Mockup : depuis le cache (préchargé) -> instantané ; sinon charge puis dessine
      if (this.cfg.mockup !== prevMockup) {
        var img = cacheImg(this.cfg.mockup);
        var apply = function () { self.mockupImg = img; self._draw(); if (on) self._showEngraving(); };
        if (img && img.complete && img.naturalWidth) { apply(); }
        else { this.mockupImg = null; if (img) img.addEventListener('load', apply, { once: true }); }
      } else {
        this._draw();
      }
      this._preloadFont();

      // La galerie est re-rendue au changement de variante (elle peut vider #engraving-preview).
      // Si la gravure est active, on ré-affiche l'aperçu en plusieurs passes pour le récupérer.
      if (on) {
        this._showEngraving();
        [200, 500, 1000].forEach(function (ms) { setTimeout(function () { if (self.checkbox && self.checkbox.checked) self._showEngraving(); }, ms); });
      }
    }

    _preloadMockups() {
      for (var k in this.map) { if (this.map[k] && this.map[k].mockup) cacheImg(this.map[k].mockup); }
    }

    _scheduleReapply() {
      var self = this;
      if (self._raf) return;
      self._raf = requestAnimationFrame(function () { self._raf = null; self._applyConfig(); });
    }

    /* ---------------------------------------------------------------- Preview */
    // Le thème re-rend la galerie au changement de variante et peut SUPPRIMER #engraving-preview.
    // On le recrée alors dans <product-gallery> pour que l'aperçu survive à chaque re-render.
    previewEl() {
      var el = document.getElementById('engraving-preview');
      if (!el) {
        var pg = document.querySelector('product-gallery');
        if (pg) {
          el = document.createElement('div');
          el.id = 'engraving-preview';
          el.className = 'paper-frame';
          pg.insertBefore(el, pg.firstChild);
        }
      }
      return el;
    }

    _ensureCanvas() {
      var host = this.previewEl();
      if (!host) return null;
      var c = host.querySelector('canvas.engraving__canvas');
      var hd = Math.round((this.cfg ? this.cfg.size : 1000) * this.ratio);
      if (!c) { c = document.createElement('canvas'); c.className = 'engraving__canvas'; host.appendChild(c); }
      if (c.width !== hd) { c.width = hd; c.height = hd; }
      this.canvas = c;
      return c;
    }

    _preloadFont() {
      var self = this;
      if (!document.fonts || !document.fonts.load || !this.cfg) return;
      try {
        document.fonts.load(this.cfg.fontSize + 'px "' + this.cfg.font + '"').then(function () { self._draw(); }).catch(function () {});
      } catch (e) {}
    }

    _draw() {
      this._ensureCanvas();
      if (!this.canvas || !this.mockupImg || !this.cfg) return;
      var ctx = this.canvas.getContext('2d');
      var S = this.cfg.size;
      ctx.setTransform(this.ratio, 0, 0, this.ratio, 0, 0);
      ctx.clearRect(0, 0, S, S);
      ctx.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';
      var iw = this.mockupImg.naturalWidth || S, ih = this.mockupImg.naturalHeight || S;
      var scale = Math.max(S / iw, S / ih);
      var dw = iw * scale, dh = ih * scale;
      ctx.drawImage(this.mockupImg, (S - dw) / 2, (S - dh) / 2, dw, dh);

      var text = (this.wording && !this.wording.disabled) ? this.wording.value : '';
      if (this.cfg.uppercase) text = text.toUpperCase();
      if (!text) return;

      // (origin top-left à (refX, refY), align gauche, baseline haut). PAS de centrage.
      var stack = '"' + this.cfg.font + '", "Optima Nova", "Candara", "Segoe UI", "Helvetica Neue", sans-serif';
      var fs = this.cfg.fontSize;
      var ls = this.cfg.letterSpacing;
      var setFont = function (size) {
        ctx.font = size + 'px ' + stack;
        if ('letterSpacing' in ctx) ctx.letterSpacing = (size * ls / 1000) + 'px';
      };
      setFont(fs);
      // autoScale (optionnel) : réduit la taille si le texte dépasse la longueur dispo.
      // - mode ANCRÉ (Memo) : la longueur dispo est refHeight (texte vertical, ancré haut-gauche).
      // - mode CENTRÉ (Floraïku) : la longueur dispo est refWidth (texte horizontal, centré dans le refRect).
      var limit = this.cfg.centered ? this.cfg.refWidth : this.cfg.refHeight;
      if (this.cfg.autoScale && limit > 0) {
        var tw = ctx.measureText(text).width;
        if (tw > limit) { fs = fs * limit / tw; setFont(fs); }
      }

      ctx.save();
      if (this.cfg.centered) {
        // origin center, align center, baseline middle, au milieu du refRect).
        ctx.translate(this.cfg.refX + this.cfg.refWidth / 2, this.cfg.refY + this.cfg.refHeight / 2);
        ctx.rotate(this.cfg.angle * Math.PI / 180);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
      } else {
        // ANCRÉ haut-gauche puis rotation (Memo).
        ctx.translate(this.cfg.refX, this.cfg.refY);
        ctx.rotate(this.cfg.angle * Math.PI / 180);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
      }

      // Lisibilité (effet « gravé ») : ombre portée subtile derrière le texte or, utile sur les
      // flacons clairs où l'or seul manque de contraste. Réglable (couleur/opacité/flou/décalage).
      if (this.cfg.shadowBlur > 0 || this.cfg.shadowX || this.cfg.shadowY) {
        ctx.save();
        ctx.shadowColor = this.cfg.shadowColor;
        ctx.shadowBlur = this.cfg.shadowBlur;
        ctx.shadowOffsetX = this.cfg.shadowX;
        ctx.shadowOffsetY = this.cfg.shadowY;
        ctx.fillStyle = this.cfg.textColor;
        ctx.fillText(text, 0, 0); // 1er passage : pose l'ombre
        ctx.restore();
      }
      if (this.cfg.strokeWidth > 0) {
        ctx.lineWidth = this.cfg.strokeWidth;
        ctx.strokeStyle = this.cfg.strokeColor;
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        ctx.strokeText(text, 0, 0);
      }
      ctx.fillStyle = this.cfg.textColor;
      ctx.fillText(text, 0, 0); // texte or net par-dessus (sans ombre)
      ctx.restore();
    }

    /* ------------------------------------------------------------- Interactions */
    _onToggle(on, focus) {
      if (this.wordingWrap) this.wordingWrap.hidden = !on;
      if (this.wording) {
        this.wording.disabled = !on;
        this.wording.required = on;
        if (on && focus) { try { this.wording.focus(); } catch (e) {} }
      }
      if (this.priceInput) {
        this.priceInput.disabled = !on;
        this.priceInput.value = on && this.cfg ? String(this.cfg.feeMajor) : '';
      }
      if (this.flagInput) { this.flagInput.disabled = !on; } // « Engraving=yes » soumis seulement si gravé
      this.classList.toggle('is-on', on);       // sélecteur « texte » : libellé en gras si actif
      // Mode swatch : refléter l'état dans les radios (restauration / changement programmatique)
      if (this.swatches && this.swatches.length) {
        this.swatches.forEach(function (r) { r.checked = (r.value === 'yes') === on; });
      }
      this._updateCount();
      this._updatePrice(on);                    // affiche le surcoût près du bouton d'achat
      this._persist();
      if (on) this._showEngraving(); else this._restoreGallery();
    }

    // Prix RECALCULÉ sur le bouton d'achat (total = prix + gravure, multi-devises, sans .00).
    // Un observer recapture le prix de base quand le thème le re-rend (changement de variante)
    // pour ré-appliquer la gravure sans double-compter.
    _initPriceWatch() {
      if (this.dataset.updatePrice !== '1') return;
      var self = this;
      (this._priceObservers || []).forEach(function (o) { o.disconnect(); });
      this._priceObservers = [];
      var containers = document.querySelectorAll('buy-buttons, .product-sticky-bar');
      [].forEach.call(containers, function (c) {
        var obs = new MutationObserver(function () { self._scanAndApply(); });
        obs.observe(c, { childList: true, characterData: true, subtree: true });
        self._priceObservers.push(obs);
      });
      this._scanAndApply();
    }

    // Pose des valeurs DÉTERMINISTES (calculées en Liquid) -> idempotent : ré-exécuter ne cumule jamais.
    _scanAndApply() {
      if (this.dataset.updatePrice !== '1' || !this.cfg) return;
      var on = !!(this.checkbox && this.checkbox.checked && this.cfg.fee > 0);
      var target = on ? this.cfg.totalMoney : this.cfg.baseMoney;
      if (target == null) return;
      target = String(target).trim();
      // ⚠️ MULTI-DEVISE : en EUR primaire le format monnaie enveloppe le prix dans <span class="money">,
      // mais les marchés étrangers (£, CHF, $, DHS…) ont un format SANS ce span -> le prix est un nœud
      // texte direct dans <sale-price>. On gère les DEUX structures, sinon le surcoût ne s'affiche pas
      // hors euro (le bouton ne bouge pas).
      var sps = document.querySelectorAll('buy-buttons sale-price, .product-sticky-bar sale-price');
      [].forEach.call(sps, function (sp) {
        var moneyEl = sp.querySelector('.money');
        if (moneyEl) {
          if (moneyEl.textContent.trim() !== target) moneyEl.textContent = target;
          return;
        }
        var sr = sp.querySelector('.sr-only');
        var cur = '';
        [].forEach.call(sp.childNodes, function (n) { if (n !== sr) cur += (n.textContent || ''); });
        if (cur.trim() !== target) {
          [].slice.call(sp.childNodes).forEach(function (n) { if (n !== sr) sp.removeChild(n); });
          sp.appendChild(document.createTextNode(target));
        }
      });
    }

    _updatePrice() {
      if (this.dataset.updatePrice !== '1') return;
      if (!this._priceObservers || !this._priceObservers.length) this._initPriceWatch();
      this._scanAndApply();
    }

    _onWording() {
      if (this.cleanRe && this.wording) {
        var cleaned = this.wording.value.replace(this.cleanRe, '');
        if (cleaned !== this.wording.value) {
          var pos = this.wording.selectionStart;
          this.wording.value = cleaned;
          try { this.wording.setSelectionRange(pos - 1, pos - 1); } catch (e) {}
          this._showAlert(this.dataset.msgForbidden || 'Character not allowed');
        }
      }
      this._updateCount();
      this._persist();
      this._draw();
      if (this.checkbox && this.checkbox.checked) this._showEngraving();
    }

    _updateCount() {
      if (!this.countEl || !this.wording) return;
      var max = this.wording.maxLength > 0 ? this.wording.maxLength : null;
      var len = this.wording.value.length;
      if (len === 0) {
        // état initial / vide : nombre max du FORMAT courant (le placeholder invite déjà à écrire).
        // On substitue le nombre dans le libellé traduit pour rester juste après un changement de variante.
        var label = this.dataset.maxlabel || (max ? max + ' characters maximum' : '');
        if (max) label = label.replace(/\d+/, max);
        this.countEl.textContent = label;
        this.countEl.className = 'engraving__count is-prompt';
      } else {
        this.countEl.textContent = max ? (len + ' / ' + max) : String(len);
        this.countEl.className = 'engraving__count' + (max && len >= max ? ' is-max' : '');
      }
    }

    _showAlert(msg) {
      if (!this.alertEl) return;
      var el = this.alertEl;
      el.textContent = msg;
      el.classList.add('is-shown');
      clearTimeout(this._alertT);
      this._alertT = setTimeout(function () { el.classList.remove('is-shown'); }, 1800);
    }

    _persist() {
      window.__memoEngrState = {
        on: !!(this.checkbox && this.checkbox.checked),
        wording: this.wording ? this.wording.value : '',
        product: this.dataset.product || ''   // pour ne PAS restaurer l'état sur un AUTRE produit
      };
    }

    /* ----------------------------------------- Bascule galerie <-> aperçu */
    // Remet #engraving-preview à sa place d'origine (dans la galerie) s'il a été déplacé (mobile).
    _movePreviewHome() {
      var $p = this.previewEl(); if (!$p || !this._pvHome || !this._pvHome.parent) return;
      if ($p.parentElement === this._pvHome.parent) return;
      if (this._pvHome.next && this._pvHome.next.parentElement === this._pvHome.parent) this._pvHome.parent.insertBefore($p, this._pvHome.next);
      else this._pvHome.parent.appendChild($p);
    }

    // Réinitialise complètement la galerie (annule tout masquage), quel que soit le viewport.
    _galleryReset() {
      var thumbs = document.querySelector('.product-gallery__thumbnail-list'); if (thumbs) thumbs.style.opacity = '';
      var list = document.querySelector('.product-gallery__image-list'); if (list) { list.style.display = ''; list.style.pointerEvents = ''; }
      var nav = document.querySelector('.product-gallery carousel-navigation'); if (nav) nav.style.opacity = '';
      ['.pn-gal-arrow', '.pn-thumb'].forEach(function (sel) { document.querySelectorAll(sel).forEach(function (el) { el.style.opacity = ''; el.style.pointerEvents = ''; }); });
    }

    _showEngraving() {
      var $p = this.previewEl(); if (!$p) return;
      var desktop = window.innerWidth >= DESKTOP_MIN;
      if (desktop) {
        // overlay dans la galerie : on remet l'aperçu chez lui puis on masque la galerie
        this._movePreviewHome();
        var thumbs = document.querySelector('.product-gallery__thumbnail-list'); if (thumbs) thumbs.style.opacity = 0;
        // On NE masque PAS l'image-list en display:none : ça casse la synchro du visuel de variante du
        // thème (au switch 30->200 gravure active, puis désactivation, l'ancien visuel réapparaissait).
        // Le canvas 4:5 OPAQUE la recouvre entièrement ; à la désactivation la galerie (re-synchronisée) réapparaît.
        var list = document.querySelector('.product-gallery__image-list'); if (list) { list.style.display = ''; list.style.pointerEvents = 'none'; }
        var nav = document.querySelector('.product-gallery carousel-navigation'); if (nav) { nav.style.transition = 'opacity 0.3s ease'; nav.style.opacity = 0; }
        // Taille STRICTEMENT identique au visuel produit : on mesure la boîte de l'image active
        // et on cale l'aperçu dessus, au pixel (les ratios CSS ne suffisaient pas).
        try {
          // Réf = la boîte réellement VISIBLE. Sur les templates avec paper-frame (parfum) on la prend.
          // Sur filage (galerie sombre SANS paper-frame, carrousel de 16 médias), le PREMIER média est
          // souvent scrollé hors écran : on cible donc le média ACTIF (aria-current / is-initial), sinon
          // la boîte de l'image-list (le viewport), et seulement en dernier recours le premier média.
          // ⚠️ Ordre CRUCIAL : le conteneur .product-gallery__image-list est le VIEWPORT stable
          // (toujours à la position visible) ; les .product-gallery__media, eux, TRANSLATENT avec le
          // carrousel au changement de senteur (le média inactif part à x négatif hors écran). On vise
          // donc le viewport AVANT tout média, sinon l'aperçu se cale sur un média scrollé hors écran.
          var ref = document.querySelector('.product-gallery__image-list .paper-frame')
                 || document.querySelector('.product-gallery__image-list')
                 || document.querySelector('.product-gallery__image-list .product-gallery__media[aria-current="true"]')
                 || document.querySelector('.product-gallery__image-list .product-gallery__media.is-initial')
                 || document.querySelector('.product-gallery__image-list .product-gallery__media')
                 || list;
          var host = $p.offsetParent || document.querySelector('product-gallery');
          if (ref && host) {
            var rb = ref.getBoundingClientRect(), hb = host.getBoundingClientRect();
            if (rb.width > 10 && rb.height > 10) {
              $p.style.top = (rb.top - hb.top) + 'px';
              $p.style.left = (rb.left - hb.left) + 'px';
              $p.style.width = rb.width + 'px';
              $p.style.height = rb.height + 'px';
              $p.style.padding = '12px';                 // même marie-louise (12px) que le cadre produit
              $p.style.background = 'rgb(247,247,245)';   // même fond papier
              $p.style.boxSizing = 'border-box';
            }
          }
          // Gravure active : on masque aussi les flèches / vignettes de changement de visuel.
          ['.pn-gal-arrow', '.pn-thumb'].forEach(function (sel) { document.querySelectorAll(sel).forEach(function (el) { el.style.opacity = 0; el.style.pointerEvents = 'none'; }); });
        } catch (e) {}
      } else {
        // mobile : la galerie reste visible, l'aperçu passe juste au-dessus du bouton d'achat
        this._galleryReset();
        var buy = document.querySelector('div[data-block-type="buy-buttons"]') || document.querySelector('buy-buttons');
        if (buy && buy.parentElement && $p.parentElement !== buy.parentElement) buy.before($p);
      }
      this._ensureCanvas();
      this._draw();
      $p.style.opacity = 1; $p.style.zIndex = 2; $p.style.display = 'block';
      // Mode « in-flow » (Floraïku) : l'aperçu prend la place de la galerie masquée et occupe la
      // largeur de la colonne (sinon le canvas s'affiche à sa taille intrinsèque). On ne touche
      // PAS au positionnement quand ce mode est off (Memo : géré par sa propre CSS).
      if (this.dataset.previewInflow === '1') { $p.style.position = 'relative'; $p.style.width = '100%'; }
    }

    _restoreGallery() {
      var $p = this.previewEl();
      this._movePreviewHome();   // toujours remettre l'aperçu dans la galerie
      this._galleryReset();      // toujours ré-afficher la galerie (annule tout masquage résiduel)
      if ($p) {
        $p.style.opacity = 0; $p.style.zIndex = -1; $p.style.display = '';
        // in-flow : on REND la main à la CSS (position absolute, opacity 0) -> aucun espace réservé.
        if (this.dataset.previewInflow === '1') { $p.style.position = ''; $p.style.width = ''; $p.style.display = 'none'; }
      }
    }

}

  customElements.define('engraving-option', EngravingOption);
})();
